import { Col, Row } from "antd";

export const TheSchoolTheLandThatBoreThee = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="the-school-the-land-that-bore-thee">
          The School, The Land That Bore Thee
        </h1>
        <h2>A Tribute to Mr Nahil Wijesuriya</h2>
      </div>

      <Row justify="center">
        <Col xs={24} lg={20}>
          <p>
            <em>The school, the land that bore thee.</em>
          </p>
          <p>
            How magnificently those ancient words seem to have awaited the life
            of Mr Nahil Wijesuriya. For from that red earth of Kandy, beneath
            the familiar hills and beneath the colours of Red, Gold and Blue,
            there came a son who would travel far, rise high and gather unto
            himself the abundance of a remarkable life, yet never allow the
            place that first gave him his wings to become merely a memory. The
            world may have widened before him, fortunes may have been won and
            horizons crossed, but somewhere within the man there has remained
            that first and sacred allegiance to the school upon the hill. And
            over the passing of decades, Mr Nahil Wijesuriya has returned that
            allegiance not in words alone, but in a munificence whose reach has
            touched playing fields, classrooms, fellow Old Trinitians and,
            ultimately, generations of boys who have yet to know his name.
          </p>
          <p>
            The measure of the man, however, is perhaps best discovered not in
            the magnificence of the fortune he would one day command, but in
            what he was prepared to surrender before that fortune had arrived.
            When Trinity cricket needed a properly qualified coach and the
            College could not readily provide the means, the young Mr Nahil
            Wijesuriya contributed Rs.150,000 towards establishing a fund. His
            entire personal asset base at the time was only about Rs.300,000.
            Half of everything he possessed went towards his school. There is a
            nobility in that which no later figure can eclipse, because it was
            generosity born not of abundance, but of conviction.
          </p>
          <p>
            The years thereafter brought a succession of interventions that
            seem, in retrospect, to form a magnificent tapestry of foresight
            and affection. When Trinity's batsmen needed the challenge of
            genuine pace, a John Edrich bowling machine came from Britain,
            described as the first in Sri Lanka. When the swimming pool
            required cement and steel, Mr Nahil Wijesuriya supplied them. When
            Trinity stood upon the threshold of the computer age, he provided a
            Computer Centre. The gifts differed in nature and scale, yet each
            sprang from the same instinct: that the young men of Trinity should
            not be constrained by want when opportunity could be placed within
            their reach.
          </p>
          <p>Then Asgiriya called.</p>
          <p>
            When the old Old Trinitians Sports Club clubhouse had to yield to
            the transformation of that hallowed ground into an international
            cricket venue, the fraternity faced the loss of more than bricks
            and mortar. A gathering place of generations was disappearing, and
            with it threatened the physical embodiment of friendships that had
            begun in school and endured into manhood. Mr Nahil Wijesuriya
            stepped forward and funded the new clubhouse, with his father, the
            late civil engineer Gratian Wijesuriya, playing a decisive part in
            bringing the building to life. Opened in 1990, it became a home not
            merely for a sporting club, but for an enduring brotherhood. At
            Asgiriya, Old Trinitians could continue to meet beneath a roof made
            possible by one of their own, and the great inheritance of
            friendship could pass undiminished from one generation to another.
          </p>
          <p>
            There is something particularly moving about that gift. Trinity
            had given these men a common beginning; Mr Nahil Wijesuriya helped
            give them a place in which that common beginning could continue to
            breathe.
          </p>
          <p>
            The years gathered momentum, and so did the scale of his
            generosity. His contribution of Rs.106.7 million towards the
            Trinity Badminton Complex transformed an aspiration into a
            permanent sporting reality. What stands upon the ground is a
            facility; what will live within it is something infinitely greater.
            Boys who have not yet entered the College will one day walk onto
            those courts carrying racquets, ambition and the uncertain promise
            of youth. They will practise, stumble, improve, compete and perhaps
            discover within themselves a talent that might otherwise have
            remained dormant. They will inherit the opportunity without having
            known the sacrifice that made it possible.
          </p>
          <p>That is the quiet majesty of giving.</p>
          <p>
            The giver remembers the cost; the generation that follows inherits
            the gift.
          </p>
          <p>
            And then came 2026, when the story rose into a realm almost beyond
            ordinary comprehension. Mr Nahil Wijesuriya endowed Trinity College
            with Rs.3 billion, creating an endowment whose purpose reaches
            beyond the present into the educational and institutional future of
            the College. It was not simply another magnificent contribution to
            another worthy cause. It was a declaration of faith in Trinity's
            tomorrow, an act of such extraordinary scale that its influence
            will extend towards boys who have not yet been born, boys whose
            names Mr Nahil Wijesuriya will never know and whose lives
            nevertheless may be altered by the generosity of a man who
            remembered his own beginning.
          </p>
          <p>And suddenly the whole journey assumes a remarkable symmetry.</p>
          <p>
            The young Old Trinitian with Rs.300,000 to his name gave half of it
            to Trinity cricket. Decades later, the same son of Trinity returned
            with Rs.3 billion for the future of the institution. Between those
            two figures lies not merely the story of accumulated wealth, but the
            far more compelling story of accumulated gratitude.
          </p>
          <p>
            That is why the arithmetic, astonishing though it is, cannot
            possibly be the final measure of Mr Nahil Wijesuriya.
          </p>
          <p>His true account is written elsewhere.</p>
          <p>
            It is written in the young cricketer who had the opportunity to
            confront genuine pace; in the student who encountered the new world
            of technology; in the Old Trinitian who found a home at Asgiriya;
            in the young badminton player whose horizons widened beneath a
            proper roof; and in the generations yet to come who will inherit
            the strength of an endowment established by a son whose loyalty
            refused to diminish with time.
          </p>
          <p>
            And so, perhaps, we are entitled to ask the question that lies
            quietly beneath this extraordinary story: is Trinity indebted to Mr
            Nahil Wijesuriya, or is Mr Nahil Wijesuriya indebted to Trinity?
          </p>
          <p>
            Trinity gave him his beginning, his education, his friendships and
            that mysterious, indestructible sense of belonging that every true
            Old Trinitian carries beyond the gates. Mr Nahil Wijesuriya has
            spent a lifetime returning that inheritance, not with a single
            grand gesture, but through a succession of acts whose cumulative
            effect has become part of the very fabric of the College and the
            fraternity that surrounds it.
          </p>
          <p>The debt, perhaps, was never meant to be settled.</p>
          <p>It was meant to be honoured.</p>
          <p>
            And now it is for us, the grateful sons of Trinity, to do precisely
            that. Not with perfunctory applause, nor with the transient ceremony
            that accompanies an occasion and then vanishes into the archives,
            but with the enduring recognition that a life of such fidelity
            deserves. Mr Nahil Wijesuriya has given Trinity something precious:
            the example of an Old Boy whose success did not estrange him from
            his beginnings, but enabled him to return to them with ever greater
            generosity.
          </p>
          <p>That is a lesson worthy of remembrance.</p>
          <p>That is a legacy worthy of reverence.</p>
          <p>
            And when the grand figures have ceased to astonish, when the years
            have softened the edges of buildings and the names of today's boys
            have become tomorrow's memories, perhaps we shall finally
            understand where the real wealth lies.
          </p>
          <p>
            For where is the fortune that could buy the cheers that roll when
            the Red, Gold and Blue rise as one? Where is the treasure that could
            purchase that extraordinary moment when the crowd becomes a single
            voice, when the pulse quickens, the heart rises and a young
            Trinitian gathers himself for one last glorious charge towards the
            twilight goal?
          </p>
          <p>No vault can contain it.</p>
          <p>No ledger can measure it.</p>
          <p>No fortune can buy it.</p>
          <p>That wealth belongs to the generations.</p>
          <p>
            And so, Mr Nahil Wijesuriya, yours is not simply a story of what you
            gave. It is the story of what your giving has become. You have
            returned buildings where there were needs, opportunity where there
            were limitations, fellowship where there was loss and, ultimately,
            a measure of permanence where every institution must otherwise
            confront the uncertainty of time.
          </p>
          <p>
            You have taken the fortune of a lifetime and allowed a portion of
            it to become somebody else's beginning.
          </p>
          <p>Perhaps that is the noblest definition of wealth.</p>
          <p>
            And perhaps the school, the land that bore thee, could ask no
            greater tribute from one of her sons.
          </p>
          <p>
            For one day, when the years have gathered around us and the familiar
            voices have fallen silent, the old colours will still fly. The
            young will still run onto the field. The cheers will still rise from
            Asgiriya. The friendships will still be forged. And somewhere
            within that continuing pageant of Trinity life will be the invisible
            imprint of Mr Nahil Wijesuriya, a son who came back to his school
            not merely carrying the rewards of his journey, but carrying the
            means to make the journeys of others greater.
          </p>
          <p>
            Then, as the light begins to soften over the hills, perhaps the
            words of that other beloved Trinity song will acquire an almost
            haunting significance:
          </p>
          <blockquote>
            <p>
              The shadows are falling around me,
              <br />I hear a great roar like the sea,
              <br />And in the pavilion they're shouting,
              <br />&quot;You're winning, well played, Trinity.&quot;
            </p>
          </blockquote>
          <p>What a fitting benediction for a life of giving.</p>
          <p>
            For the shadows will indeed fall one day, as they must upon us all.
            But the roar will remain. It will rise from fields and courts, from
            classrooms and clubhouses, from the voices of Old Trinitians and
            the laughter of young men who will know only that Trinity gave them
            an opportunity to become what they might.
          </p>
          <p>
            And perhaps, when that great roar rises like the sea, it will carry
            with it something more than the triumph of a team.
          </p>
          <p>It will carry the gratitude of a school.</p>
          <p>It will carry the memory of a son.</p>
          <p>It will carry the name of Mr Nahil Wijesuriya.</p>
          <p>
            And if the final words of the song are ever sung softly into the
            fading light, they will not be an ending at all, but a promise that
            what was given in love shall continue to live in those who come
            after.
          </p>
          <p>
            For and on behalf of every grateful Trinitian,
            <br />
            <strong>Tyrone Smith</strong>
            <br />
            <em>Till the last bell calls</em>
          </p>
        </Col>
      </Row>
    </div>
  );
};